import type { RouteObject } from 'react-router'

import { lazy } from '../../../routes/lazy'
import { path } from '../../../routes/paths'
import { AdminLayout } from './AdminLayout'
import { AdminSettings } from './AdminSettings'

export const adminRoutes: RouteObject[] = [
  {
    element: <AdminLayout />,
    children: [
      {
        index: true,
        Component: lazy(() => import('@features/admin/routes/SoftwareReleases'))
      },
      {
        path: path.adminUsers,
        Component: lazy(() => import('@features/admin/routes/ManageUsers'))
      },
      {
        path: path.adminUser,
        Component: lazy(() => import('@features/admin/routes/EditUser'))
      },
      {
        path: path.adminOperations,
        Component: lazy(() => import('@features/admin/routes/ManageOperations'))
      },
      {
        path: path.adminStats,
        Component: lazy(() => import('@features/admin/routes/PanoramaStats'))
      },
      {
        path: path.adminSettings,
        element: <AdminSettings />
      }
    ]
  }
]
